// QuoteLayout.tsx
import { Box } from "@mui/material";
import { quoteModern } from "../style/style";

export const QuoteLayout = ({ children, role }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: quoteModern.colors.pageBg,
        py: { xs: 2, md: 3 },
        px: { xs: 1.5, md: 2 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 920,
          mx: "auto",
          bgcolor: quoteModern.colors.sheetBg,
          borderRadius: 3,
          p: { xs: 2, md: 3 },
          boxShadow: "0px 16px 50px rgba(15, 23, 42, 0.08)",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
